import { render, staticRenderFns } from "./contractmanagement.vue?vue&type=template&id=5b902d80&scoped=true"
import script from "./contractmanagement.vue?vue&type=script&lang=js"
export * from "./contractmanagement.vue?vue&type=script&lang=js"
import style0 from "./contractmanagement.vue?vue&type=style&index=0&id=5b902d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b902d80",
  null
  
)

export default component.exports